import { login } from '../../../global_env'
import { navigateTo } from '../../../utils/ui'
import { FnBridge } from './fn_bridge'
import { goDaCheF } from '../../../utils/guide_app_home'

const SDK_Methods = {
  login,
  // TODO: 这个方法也不太好，createOrder 现在和 page 耦合太多了，尝试 creatOrder 再解耦一下
  createOrder() {
    FnBridge.createOrder && FnBridge.createOrder(arguments)
  },
  refreshDetailInfo() {
    FnBridge.refreshDetailInfo && FnBridge.refreshDetailInfo()
  },
  goIndex() {
    navigateTo('index')
  },
  goRide(params) {
    goDaCheF({
      productType: params.productType,
      apolloPage: 'pay_result',
    })
  },
}

export const ComponentsMixin = {
  properties: {
    theme: {
      type: String,
      value: 'normal',
    },
    mallData: {
      type: Object,
      value: () => {
        return {}
      },
    },
  },
  methods: {
    callMall(method, ...args) {
      return SDK_Methods[method] && SDK_Methods[method].call(this, ...args)
    },
    callPageMethod(method, ...args) {
      this.triggerEvent('mall-page-event', {
        method,
        args,
      })
    },
  },
}
